/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateContactResponseData,
  CreateContactResponseDataFromJSON,
  CreateContactResponseDataFromJSONTyped,
  CreateContactResponseDataToJSON
} from './CreateContactResponseData'

/**
 *
 * @export
 * @interface CreateContactResponse
 */
export interface CreateContactResponse {
  /**
   *
   * @type {number}
   * @memberof CreateContactResponse
   */
  status?: number
  /**
   *
   * @type {CreateContactResponseData}
   * @memberof CreateContactResponse
   */
  data?: CreateContactResponseData
}

export function CreateContactResponseFromJSON(json: any): CreateContactResponse {
  return CreateContactResponseFromJSONTyped(json, false)
}

export function CreateContactResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateContactResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateContactResponseDataFromJSON(json['data'])
  }
}

export function CreateContactResponseToJSON(value?: CreateContactResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateContactResponseDataToJSON(value.data)
  }
}
